import clsx from 'clsx';
import LegacySemanticUiIcon from 'components/common/LegacySemanticUiIcon/LegacySemanticUiIcon';
import Link from 'next/link';
import type { HeaderBanner } from 'types/ui/HeaderBanner';

import styles from './Banner.module.css';

interface IBannerProps {
  bannerContent: HeaderBanner;
  leftAligned?: boolean;
}

const Banner = ({ bannerContent, leftAligned = false }: IBannerProps) => {
  if (bannerContent.customContent) {
    return bannerContent.customContent;
  }
  const renderBannerContent = () => (
    <div className={styles.bannerContainer}>
      <button
        type="button"
        className={clsx(
          styles.textContainer,
          leftAligned ? styles.leftAligned : '',
          !bannerContent?.tapHandler ? styles.removePointer : '',
        )}
        onClick={() => bannerContent?.tapHandler && bannerContent.tapHandler()}
      >
        {bannerContent.faIconName && (
          <LegacySemanticUiIcon
            name={bannerContent.faIconName}
            className={styles.bannerIcon}
          />
        )}
        <div className={styles.bannerContent}>{bannerContent.content}</div>
      </button>
    </div>
  );

  return bannerContent.href ? (
    <Link href={bannerContent.href}>{renderBannerContent()}</Link>
  ) : (
    renderBannerContent()
  );
};

export default Banner;
